import styles from "../../styles/shared/RequestLiveSuggestionModal.module.css";
import { FaChevronDown, FaStore } from "react-icons/fa6";
import { FaClock, FaSyncAlt } from "react-icons/fa";
import { Select } from "antd";
import { useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { IoIosCloseCircle } from "react-icons/io";
import useFetchAllExchangesWithCoins from "../../hooks/api/useFetchAllExchangesWithCoins";
import capitalize from "antd/es/_util/capitalize";
import { LIVE_TIMEFRAMES } from "../../redux/live-suggestion/liveSuggestionSlice";

function SuggestionConfig({
  selectedCoin,
  setSelectedCoin,
  selectedExchange,
  setSelectedExchange,
  selectedTimeframe,
  setSelectedTimeframe,
  signalLoading,
  requestSuggestion,
  cancelSuggestion,
}) {
  const {
    main: { userData },
  } = useSelector((state) => state);
  const firstRenderRef = useRef(null);

  const {
    allExchangesWithCoins,
    isLoading,
    exchangeList: allExchanges,
  } = useFetchAllExchangesWithCoins();

  const assetsList = useMemo(() => {
    return (
      allExchangesWithCoins
        ?.find((item) => item?.exchange === selectedExchange)
        ?.coins?.map((item) => item?.Coin) || []
    );
  }, [allExchangesWithCoins, selectedExchange]);

  const exchangeOptions = useMemo(() => {
    return isLoading && !allExchangesWithCoins?.length
      ? [{ value: "", label: "Loading..." }]
      : allExchanges?.map((ex) => {
          return { value: ex, label: capitalize(ex) };
        });
  }, [allExchanges, allExchangesWithCoins?.length, isLoading]);

  const coinOptions = useMemo(() => {
    return isLoading && !allExchangesWithCoins?.length
      ? [{ value: "", label: "Assets Loading..." }]
      : assetsList.map((asset) => {
          return { value: asset, label: asset };
        });
  }, [allExchangesWithCoins?.length, assetsList, isLoading]);

  const timeframeOptions = useMemo(() => {
    return LIVE_TIMEFRAMES.map((frame) => ({ value: frame, label: frame }));
  }, []);

  const controlsDisabled =
    (isLoading && !allExchangesWithCoins?.length) || signalLoading;

  const selectExchange = (ex) => {
    if (!ex) return;
    setSelectedExchange(ex);
  };

  const selectAsset = (asset) => {
    if (!asset) return;
    setSelectedCoin(asset);
    firstRenderRef.current = true;
    requestSuggestion(selectedExchange, asset, selectedTimeframe);
  };

  const selectTimeframe = (frame) => {
    if (!frame || !LIVE_TIMEFRAMES.includes(frame)) return;
    setSelectedTimeframe(frame);
    firstRenderRef.current = true;
    requestSuggestion(selectedExchange, selectedCoin, frame);
  };

  // fetch signal based initial info
  useEffect(() => {
    if (
      userData?.["custom:custom_username"] &&
      selectedExchange === "binance" &&
      selectedCoin === "BTC" &&
      !firstRenderRef.current
    ) {
      firstRenderRef.current = true;
      requestSuggestion(selectedExchange, selectedCoin, selectedTimeframe);
    }
  }, [
    requestSuggestion,
    selectedCoin,
    selectedExchange,
    selectedTimeframe,
    userData,
  ]);

  return (
    <div className={styles.configBox}>
      <div className={styles.configs}>
        <div className={styles.configItem}>
          <label>
            <FaStore />
            Exchange:
          </label>
          <Select
            value={selectedExchange}
            disabled={controlsDisabled}
            options={exchangeOptions}
            suffixIcon={<FaChevronDown color="#0f1c53" />}
            onChange={selectExchange}
          />
        </div>
        <div className={styles.configItem}>
          <label>
            <FaSyncAlt />
            Pair:
          </label>
          <Select
            value={selectedCoin}
            disabled={controlsDisabled}
            options={coinOptions}
            suffixIcon={<FaChevronDown color="#0f1c53" />}
            onChange={selectAsset}
          />
        </div>
        <div className={styles.configItem}>
          <label>
            <FaClock />
            Time frame:
          </label>
          <Select
            value={selectedTimeframe}
            disabled={isLoading && !allExchangesWithCoins?.length}
            options={timeframeOptions}
            suffixIcon={<FaChevronDown color="#0f1c53" />}
            onChange={selectTimeframe}
          />
        </div>
      </div>
      {signalLoading && (
        <span onClick={cancelSuggestion} className={styles.cancelBtn}>
          <IoIosCloseCircle size={24} />
        </span>
      )}
    </div>
  );
}

export default SuggestionConfig;
